import { FormControl, FormLabel, FormHelperText } from 'beam/dist/Form'
import { RadioGroup } from 'beam/dist/Radio'
import PropTypes from 'prop-types'
import fieldPropTypes from './FieldPropTypes'
import withStyles from 'beam/dist/styles'
import { get } from 'lodash'

const styles = {
  horizontal: {
    flexDirection: 'row',
  },
}

const FormRadioGroupField = props => {
  const {
    classes,
    label,
    field,
    required,
    orientation,
    form: { errors, touched },
    children,
    fullWidth = true,
  } = props

  return (
    <FormControl
      component="fieldset"
      required={required}
      error={!!get(touched, field.name) && !!get(errors, field.name)}
      fullWidth={fullWidth}
    >
      {label && <FormLabel component="legend">{label}</FormLabel>}
      <RadioGroup
        {...field}
        className={orientation.toLowerCase() === 'horizontal' ? classes.horizontal : null}
        onChange={e => {
          field.onChange(e)
          props.onChange && props.onChange(e)
        }}
      >
        {children}
      </RadioGroup>
      <FormHelperText required={required} error={!!get(touched, field.name) && !!get(errors, field.name)}>
        {!!get(touched, field.name) && get(errors, field.name)}
      </FormHelperText>
    </FormControl>
  )
}

const radioPropTypes = {
  ...fieldPropTypes,
  orientation: PropTypes.string,
}
FormRadioGroupField.propTypes = radioPropTypes
FormRadioGroupField.defaultProps = {
  label: '',
  orientation: 'vertical',
}

export default withStyles(styles)(FormRadioGroupField)
